import React from "react";

export default function Stakeholders() {
  const stakeholders = [
    {
      title: "Employers",
      benefits: [
        "Predictable benefit spending",
        "Real-time utilization insights (non-PHI)",
        "Modular vendor integration",
        "Stop-loss & PBM optimization",
        "HRIS integration and automation"
      ]
    },
    {
      title: "Employees",
      benefits: [
        "Personalized, portable benefits",
        "Private wallet access",
        "AI-powered onboarding and support",
        "Transparent usage tracking",
        "Continued access to BUCA network"
      ]
    },
    {
      title: "Vendors",
      benefits: [
        "Instant smart contract payments",
        "Simplified reconciliation",
        "AI-assisted communication",
        "Access to tokenized marketplace",
        "Reduced billing friction"
      ]
    }
  ];

  return (
    <section className="bg-gray-50 py-20 px-6" id="stakeholders">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Built for Every Stakeholder
        </h2>
        
        <p className="text-gray-600 text-lg max-w-3xl mx-auto">
          BenefitChain delivers real value to employers, employees, and vendors — through automation, transparency, and personalized engagement.
        </p>

        <div className="grid md:grid-cols-3 gap-8 text-left mt-12">
          {stakeholders.map((stakeholder, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
              <h3 className="text-xl font-semibold mb-4 text-gray-800">
                {stakeholder.title}
              </h3>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                {stakeholder.benefits.map((benefit, benefitIndex) => (
                  <li key={benefitIndex} className="leading-relaxed">
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 